import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { oidcConfig } from "./constants/oidcConfig";
import { backendUrls } from "./constants/constants";
import "./i18n";

const container = document.getElementById("root");
const root = createRoot(container);

const oidcConfigUrl = backendUrls.oidcConfigUrl;

const onSigninCallback = (_user) => {
  var url = new URL(window.location.href);
  url.searchParams.delete("code");
  url.searchParams.delete("state");
};

sessionStorage.setItem("customerName", window.location.host.split(".")[0]);

async function startApp() {
  let oidcRuntimeConfig = { ...oidcConfig };

  try {
    const response = await fetch(
      oidcConfigUrl + `?customerName=${sessionStorage.getItem("customerName")}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.text();
    const data = JSON.parse(text);

    oidcRuntimeConfig.authority = data.authority;
    oidcRuntimeConfig.client_id = data.clientId;
  } catch (error) {
    console.error("Fetch or parsing error:", error);
    // You can decide to render a fallback component here if you want
  }

  root.render(
    <AuthProvider {...oidcRuntimeConfig} onSigninCallback={onSigninCallback}>
      <App />
    </AuthProvider>
  );
}

// Start the app
startApp();

reportWebVitals();
